// @ts-nocheck
import React, { useEffect, useState } from "react";
import { PageContainer } from "../components/AssetBreadCrumb";
import { Skeleton, SkeletonText } from "../components/Skeleton";
import { useParams } from "react-router-dom";
import { getUploadData } from "../graphql/queries";
import { generateClient } from "aws-amplify/api";
import DataUploadForm from "./DataUploadForm";

const DataUploadEditForm = () => {
  const { custommodelid } = useParams();
  const [initialRecord, setInitialRecord] = useState(null);

  const fetchCustomModel = async () => {
    const client = generateClient();
    try {
      const { data } = await client.graphql({
        query: getUploadData,
        variables: {
          id: custommodelid,
        },
      });

      setInitialRecord(data.getUploadData);
      // setCustomModelRecords(data.listUploadData.items)
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    fetchCustomModel();
  }, []);

  if (!initialRecord) {
    // Header-then-form silhouette, so the page doesn't jump when the record lands
    return (
      <PageContainer>
        <div role="status" aria-label="Loading custom model">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="mt-2 h-7 w-72" radius="md" />
          <SkeletonText lines={1} className="mt-3 max-w-md" />
          <div className="mt-8 flex flex-col gap-5">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i}>
                <Skeleton className="h-3 w-28" />
                <Skeleton className="mt-2 h-eai-control-lg w-full" radius="md" />
              </div>
            ))}
          </div>
        </div>
      </PageContainer>
    );
  }
  return <DataUploadForm initialUploadForm={initialRecord} editFlag={true} />;
};

export default DataUploadEditForm;
